import QRCode from "react-qr-code";
import { generatePixPayload } from "../../Utils/pixPayload";
import { formatPriceBRL } from "../../Utils/DataFormatters";

type Props = {
  pixKey: string;
  amount: number;
};

const InStorePixStep = ({ pixKey, amount }: Props) => {
  const payload = generatePixPayload(pixKey, amount, "Loja", "Brasil");

  return (
    <div className="flex flex-col items-center text-center flex-[1.6] bg-white border p-6 gap-4 rounded shadow">
      <h2 className="text-xl font-bold text-primary-600">{"Pagamento via PIX"}</h2>
      <p className="text-sm text-gray-600">
        {"Mostre o QR Code abaixo para o cliente escanear com o app do banco."}
      </p>
      <div className="p-4 bg-white border rounded">
        <QRCode value={payload} size={220} />
      </div>
      <div className="text-2xl font-bold text-primary-600">{formatPriceBRL(amount)}</div>
      <p className="text-xs text-gray-500">
        {"Chave PIX"}: <span className="font-medium">{pixKey}</span>
      </p>
      <p className="text-xs text-gray-500">
        {"O valor já está incluído no QR Code. O cliente só precisa confirmar no app."}
      </p>
    </div>
  );
};

export default InStorePixStep;
